import { Typography } from '@mui/material';
import * as React from 'react';
import '../common/Styles.css'
import { CONST_SITE_LABEL } from './Helper';

export default function LeftImg() {

  return (
    <div className='sign-in-left-panel'>
      <div className='logo'>
        <img src={`./${CONST_SITE_LABEL}-logo.png`} alt='Logo' width={'198'} height={'48'}
          onClick={() => window.open(process.env.REACT_APP_BUSINESS_WEBSITE_HOST)}
        />
      </div>

      <Typography textAlign={'center'} variant='h6' color={'#fff'}>Optimize Your Cloud Journey with Advanced Cloud and DevOps Solutions</Typography>

        <img src='./sign-in.png' width={'80%'} alt='Sign Up Banner' />
    </div>
  )
}